export default "/images/097258d910c645adfa1e1b729341933f.avif";